import React from 'react';

const Loader = () => (
    <div className='fixed inset-0 bg-gray-50 bg-opacity-30 flex items-center justify-center z-50'>
        <div className='loader w-24 h-24 border-t-4 border-primary rounded-full animate-spin'></div>
    </div>
);

export default Loader;
